import { createSelector } from 'reselect'

import { getEnabledCockpitOfferings } from '../../lib'

import { selectVisibleCockpitOfferingsCatalog } from './selectVisibleCockpitOfferingsCatalog'

export const selectCockpitOfferingPresentation = createSelector(
  [selectVisibleCockpitOfferingsCatalog],
  getEnabledCockpitOfferings
)
